import type { ReactNode } from "react";
import { PayoutsFrame, type PayoutsTab } from "@/pages/account/payouts/components/PayoutsFrame";

export interface AccountPayoutsDocumentsViewProps {
  /** Localized tab definitions for the payouts sub-nav. */
  tabs: PayoutsTab[];
  /** Publishable key for the Stripe Connect runtime. */
  publishableKey: string;
  /** Server-minted AccountSession client secret for the initial render. */
  initialClientSecret: string;
  /** Refreshes the Stripe Connect client secret before it expires. */
  fetchRefreshedClientSecret: () => Promise<string>;
  /** Embedded Stripe Connect components for the documents tab. */
  children: ReactNode;
}

/**
 * Presentational shell for the Payouts "Documents" tab: the shared
 * `PayoutsFrame` sub-nav wrapping the embedded Stripe Connect documents
 * components passed in as children.
 */
export function AccountPayoutsDocumentsView({
  tabs,
  publishableKey,
  initialClientSecret,
  fetchRefreshedClientSecret,
  children,
}: AccountPayoutsDocumentsViewProps) {
  return (
    <PayoutsFrame
      currentTab="documents"
      fetchRefreshedClientSecret={fetchRefreshedClientSecret}
      initialClientSecret={initialClientSecret}
      publishableKey={publishableKey}
      tabs={tabs}
    >
      {children}
    </PayoutsFrame>
  );
}
